module.exports = __webpack_public_path__ + "static/media/Skintreatmtmanagemetplatform.b8a19335.png";